export default __webpack_public_path__ + "img/2_17-daae4164.png";